import {LoadingButton} from '@mui/lab';
import {Typography} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import socket, {IResponse} from '@sockets';
import Card from '../card/Card';
import IChannel from '../network/IChannel';

interface IProps {
	channel: IChannel;
}

export default function NewsChannelItem({channel}: IProps) {
	const [loading, setLoading] = useState(false);
	const {t} = useTranslation();
	const handleJoinBtnClicked = () => {
		setLoading(true);
		socket.emit('network:join_channel', channel.id, (data: IResponse<IChannel>) => {
			if (data.success) {
				channel.isMember = true;
			} else {
				// TODO show error snack
			}
			setLoading(false);
		});
	};
	return (
		<Card key={channel.id} title={channel.name} action={!channel.isMember ?
			<LoadingButton loading={loading} onClick={handleJoinBtnClicked}>{t('membership')}</LoadingButton> : undefined}>
			<Link to={`/network/${channel.id}`} className="flex flex-row p-2 items-center">
				<img className="w-8 h-8 rounded object-cover" src={channel.image} alt={channel.name}/>
				<Typography sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.700' : 'grey.200',
					fontSize: (theme) => theme.typography.fontSize
				}} className="mx-1 overflow-hidden whitespace-nowrap overflow-ellipsis">{channel.lastMessage}</Typography>
			</Link>
		</Card>
	);
}
